import { sdk } from 'src/utilities/sdk';
import { camelizeResponseData } from 'src/utilities/http-data-casing';
import {
  BalancePaymentMethodsApiResponse,
  BalancePaymentMethodsRawResponse,
} from 'src/types/Balance';

export const getBalancePaymentMethodsEndpoint = (
  externalBalanceBuyerId: string
): string =>
  `/b2gexternalgateway/balance/buyers/${externalBalanceBuyerId}/payment-methods`;

export async function fetchBalancePaymentMethods(
  externalBalanceBuyerId: string
): Promise<BalancePaymentMethodsApiResponse> {
  const response: BalancePaymentMethodsRawResponse = await sdk.http.get(
    getBalancePaymentMethodsEndpoint(externalBalanceBuyerId)
  );
  return camelizeResponseData(response);
}
